import React from "react";

// ═══════════════════════════════════════════════════════════════
// AVATAR
//
// Pyöreä kuva tai nimen ensimmäinen kirjain. Sama ympyrä oli aiemmin
// kopioituna viiteen paikkaan hieman eri kokoisena, ja kun profiilikuvat
// lisättiin, jokainen niistä olisi pitänyt muistaa erikseen. Yksi
// komponentti pitää ne linjassa myös seuraavalla kerralla.
// ═══════════════════════════════════════════════════════════════

interface Props {
  /** Näytettävä nimi. Ensimmäistä kirjainta käytetään jos kuvaa ei ole. */
  name?: string;
  /** Profiilikuvan osoite, jos pelaaja on sellaisen asettanut. */
  photoUrl?: string | null;
  /** Ympyrän halkaisija pikseleinä. */
  size: number;
  /** Tausta kun kuvaa ei ole. */
  background?: string;
  /** Kirjaimen väri. */
  color?: string;
  /** Kirjasinkoko; oletuksena suhteessa halkaisijaan. */
  fontSize?: number;
  style?: React.CSSProperties;
}

const Avatar: React.FC<Props> = ({
  name, photoUrl, size, background = "#163b68", color = "#ffffff", fontSize, style,
}) => (
  <div style={{
    width: size, height: size, borderRadius: "50%", flexShrink: 0,
    // overflow piilottaa kuvan kulmat; ilman sitä neliökuva näkyisi
    // ympyrän ulkopuolella.
    overflow: "hidden",
    background: photoUrl ? "#eef2f7" : background,
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: fontSize ?? Math.round(size * 0.39),
    fontWeight: 700, color,
    ...style,
  }}>
    {photoUrl
      ? <img src={photoUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      : (name || "?").trim().charAt(0).toUpperCase() || "?"}
  </div>
);

export default Avatar;
